module.exports = __webpack_public_path__ + "static/media/TeamLEAD.144759a8.svg";